import { createStore } from 'jotai';

/**
 * Jotai store for the application. Use this to access Jotai atoms outside of
 * React components.
 */
export const appJotaiStore = createStore();
